import { PageHero } from "@/pages/About";

export default function CookiePolicy() {
    return (
        <div>
            <PageHero title="Cookie Notice" subtitle="How this website uses cookies" />
            <section className="gsf-section" data-testid="cookie-content">
                <div className="gsf-container max-w-3xl space-y-6 text-[color:var(--gsf-body)] leading-relaxed">
                    <p>
                        This website uses a small number of first-party cookies strictly to provide the services you
                        request. We do not use third-party advertising cookies or cross-site tracking.
                    </p>
                    <h3 className="font-serif text-xl text-[color:var(--gsf-green-700)] font-semibold mt-6">Essential cookies</h3>
                    <ul className="list-disc list-inside space-y-1">
                        <li><strong>gsf_access</strong> and <strong>gsf_refresh</strong> — session cookies for administrators only. HttpOnly, Secure, SameSite. Not set for public visitors.</li>
                    </ul>
                    <h3 className="font-serif text-xl text-[color:var(--gsf-green-700)] font-semibold">Analytics</h3>
                    <p>We may add a privacy-respecting analytics tool in future to understand how visitors use the website. Any such tool will be described here before deployment.</p>
                    <h3 className="font-serif text-xl text-[color:var(--gsf-green-700)] font-semibold">Your choices</h3>
                    <p>You can clear cookies at any time via your browser settings. Clearing administrator cookies will require you to sign in again.</p>
                    <p className="text-sm text-gray-500">Questions? Email <a className="underline text-[color:var(--gsf-green-700)]" href="mailto:impact@globalseedzim.org">impact@globalseedzim.org</a>.</p>
                </div>
            </section>
        </div>
    );
}
